import React, {useEffect, useState}  from 'react';
import { Link, NavLink } from "react-router-dom";
import {useSelector} from "react-redux";
import userImage from "../assets/images/user";
import {database} from '../firebase'
import NotificationBadge from 'react-notification-badge';
import {Effect} from 'react-notification-badge';
import { useList,useListVals } from "react-firebase-hooks/database";
import { useParams } from "react-router-dom";

function Header(){
    const [requestnum,setRequestnum]=useState([])
    const { currentUser, creditzIds = [] } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
        creditzIds: state.profile.creditzIds,
    }));
    function getConnections(uid) {
        return database
          .ref(`/connectuser/${uid}`).orderByChild('status').equalTo('Pending')
          .once("value")
          .then(async (snapshot) => {
      
            const array = [];
            snapshot.forEach((childSnapshot) => {
              array.push(childSnapshot.key);
            });
            setRequestnum(array)
            // return array;
        });
      }
      
    const Notifications = database
    .ref(`/Notifications`)
    .child(currentUser.uid).orderByChild('isread').equalTo('false')
    

   
    const FriendsList=database
    .ref(`/connectuser/${currentUser.uid}`).orderByChild('status').equalTo('Pending');

    let { id } = useParams();
    const [notificationscount] = useListVals(Notifications);


    function NotificationCOunt(){
notificationscount.map((notifiation)=>{

if(id!==undefined&&id===notifiation.sender){
    const updates = {};
    
        const updates2={};
           updates[`/Notifications/${currentUser.uid}/${notifiation.messagekey}/isread`] = "true";
           updates2[`/Notifications/${currentUser.uid}/${notifiation.messagekey}/isDeleted`] = "true";
                        
             database.ref().update(updates)
             database.ref().update(updates2) 
                        }
    
})


    }
   const [requestcount] = useList(FriendsList);

    useEffect(() => {
        const navLinks = document.querySelectorAll('.nav-item')
        navLinks.forEach((l) => {
            l.addEventListener('click', () => { 
                document.getElementById('navbarMenu').classList.remove('show');
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            })
        })
    });

  
   useEffect(()=>{

    NotificationCOunt();
   },[notificationscount])
    return (
        <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
                <Link className="navbar-brand" to="#">
                    <img src="./assets/images/logo.svg" alt="logo"/>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarMenu">
                    <form className="d-flex form-search">
                        <input className="form-control me-2" type="search" placeholder="Start typing to search.." aria-label="Search"/>
                        <svg className="icon"><use href="#icon_search"></use></svg>
                    </form>
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <NavLink className="nav-link nav-rounded" to="/Home">
                                <svg className="icon"><use href="#icon_home"></use></svg>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link nav-rounded" to="/creditz">
                                <svg className="icon"><use href="#icon_creditz"></use></svg>
                            </NavLink>
                        </li>                        
                        <li className="nav-item">
                            <NavLink className="nav-link nav-rounded" to="/Search">
                                <svg className="icon icon-1x"><use href="#icon_personsearch"></use></svg>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link nav-rounded" to="/Messages">
                                <svg className="icon"><use href="#icon_chat"></use></svg>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link nav-rounded" to="/requests">
                                <svg className="icon">
                                    <use href="#icon_link"></use></svg>
                            </NavLink>
                        </li>
                                <NotificationBadge count={requestcount.length} effect={Effect.SCALE}/>
                    </ul>
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <NavLink className="nav-link nav-rounded" to="/notifications">
                                <svg className="icon"><use href="#icon_notification"></use></svg>
                            </NavLink>
                        </li>
                        <NotificationBadge count={notificationscount.length} effect={Effect.SCALE}/>
                        <li className="nav-item">
                            <NavLink className="nav-link nav-rounded" to="/Settings">
                                <svg className="icon"><use href="#icon_settings"></use></svg>
                            </NavLink>
                        </li>
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link nav-avatar ms-2" to="/Profile2">
                                <img src={currentUser?.profileImageUrl || userImage()} alt="user"/>
                            </NavLink>
                        </li>
                    </ul>                  
                </div>
            </div>
        </nav>
    )
}
export default Header;